import React from "react";
import { NavLink, useLocation } from "react-router-dom";
import { Home, ClipboardList, Target, Trophy, Tv, Sparkles, Newspaper } from "lucide-react";
import { useI18n } from "@/lib/I18nContext";
import { useAuth } from "@/lib/AuthContext";

/**
 * Persistent bottom navigation bar with 5 icons (mobile + desktop).
 */
const ITEMS = [
  { to: "/perfil", labelKey: "footer.home", icon: Home, testid: "footer-nav-home" },
  { to: "/reglas", labelKey: "footer.rules", icon: ClipboardList, testid: "footer-nav-reglas" },
  { to: "/pronosticos/fase1", labelKey: "footer.predictions", icon: Target, testid: "footer-nav-pronosticos", match: ["/pronosticos"] },
  { to: "/ranking", labelKey: "footer.ranking", icon: Trophy, testid: "footer-nav-ranking" },
  { to: "/todos", labelKey: "footer.realScores", icon: Tv, testid: "footer-nav-marcadores" },
];

const SPECIAL_ITEMS = [
  { to: "/pollas-especiales", labelKey: "nav.specialPools", icon: Sparkles, testid: "footer-nav-pollas-especiales" },
  { to: "/noticias", labelKey: "nav.news", icon: Newspaper, testid: "footer-nav-noticias" },
];

export default function BottomNav() {
  const { pathname } = useLocation();
  const { t } = useI18n();
  const { user } = useAuth();
  const isSpecialOnly = !!user?.is_special_only && !user?.is_admin;
  const items = isSpecialOnly ? SPECIAL_ITEMS : ITEMS;
  return (
    <nav
      data-testid="bottom-nav"
      className="fixed bottom-0 inset-x-0 z-30 bg-black/95 backdrop-blur border-t border-zinc-800"
      role="navigation"
      aria-label="Footer navigation"
    >
      <ul className={`max-w-5xl mx-auto grid ${items.length === 5 ? "grid-cols-5" : `grid-cols-${items.length}`}`}>
        {items.map((it) => {
          const Icon = it.icon;
          const isActive =
            pathname === it.to ||
            (it.match && it.match.some((p) => pathname.startsWith(p)));
          return (
            <li key={it.to} className="flex">
              <NavLink
                to={it.to}
                data-testid={it.testid}
                className={`relative flex-1 flex flex-col items-center justify-center gap-1 py-2 px-1 text-[10px] uppercase tracking-wider transition-colors ${
                  isActive ? "text-[var(--c-lime)]" : "text-zinc-400 hover:text-white"
                }`}
              >
                <Icon size={20} strokeWidth={isActive ? 2.4 : 2} />
                <span className="text-center leading-tight px-0.5 line-clamp-2">
                  {t(it.labelKey)}
                </span>
                {isActive && (
                  <span className="absolute top-0 left-1/2 -translate-x-1/2 w-8 h-0.5 bg-[var(--c-lime)]" />
                )}
              </NavLink>
            </li>
          );
        })}
      </ul>
    </nav>
  );
}
